import { data } from 'jquery'
import request from '../baseUtils/request'
import {
	MaterialCardData,
	AudioItem,
	VideoItem,
	PointsDetail,
	PointsItem,
	ResponseLoginInfo,
	Response,
	QueryParams,
	ListResponse
} from '../types'

/**
 * 获取生成的音乐列表
 * @returns
 */
export function generateAudioList(data: {
	pageNum: number
	pageSize: number
	keyword: string
	status?: number // 1 2: 成功或生成中 3: 全部
}): Promise<Response<AudioItem[]>> {
	return request({
		method: 'post',
		url: '/audio/generateAudio/list',
		data
	})
}

/**
 * 获取生成的音乐成功列表
 * @returns
 */
export function generateAudioSuccessList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<AudioItem[]>> {
	return request({
		method: 'post',
		url: '/user/product/getAiMusicProduct/list ',
		data
	})
}

/**
 * 获取背景音库列表
 * @returns
 */
export function getBgmList(data: {
	pageNum: number
	pageSize: number
	videoType: string
}): Promise<Response<AudioItem[]>> {
	return request({
		method: 'post',
		url: '/audio/getBgmList',
		data
	})
}
export function generateList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<AudioItem[]>> {
	return request({
		method: 'post',
		url: '/conference/getWorks',
		data
	})
}

export type DraftType = 0 | 1 | 2 | 3 | 4 | 5 | 6
interface DraftParams {
	pageNum: number
	pageSize: number
	draftType: DraftType //0-全部   1:极速成片 2:视频转译 3:素材成片
	keyword: string
}

export interface Draft {
	autoId: number
	name: string
	url: string
	duration: number
	draftJson: string
	createTime: string
	updateTime: string
	thumbnailUrl: string
	isTemplate: number
	templateClassify: string | null
	isDelete: number
	videoDirection: string
	createUserId: string
	productId: string
	draftType: DraftType // 0 全部 1:极速成片 2:视频转译 3:素材成片
	showType?: boolean
}
// 获取草稿全部列表
export function getDraftAllList(data: any): Promise<Response<Draft[]>> {
	data.draftType = 0
	return request({
		method: 'POST',
		url: '/ovs/draft/list',
		data
	})
}

// 获取极速成片草稿全部列表
export function getDraftFastList(data: any): Promise<Response<Draft[]>> {
	data.draftType = 1
	return request({
		method: 'POST',
		url: '/ovs/draft/list',
		data
	})
}

// 获取素材成片草稿全部列表
export function getDraftMaterialList(data: any): Promise<Response<Draft[]>> {
	data.draftType = 3
	return request({
		method: 'POST',
		url: '/ovs/draft/list',
		data
	})
}

// 获取MV视频草稿全部列表
export function getDraftMvList(data: any): Promise<Response<Draft[]>> {
	data.draftType = 5
	return request({
		method: 'POST',
		url: '/ovs/draft/list',
		data
	})
}

/**
 * portal最新视频/ 我的作品里视频成片
 * @returns
 */
export function getProduct(): Promise<Response<VideoItem[]>> {
	return request({
		method: 'GET',
		url: '/user/product/getProduct'
	})
}

/**
 * 分页获取视频列表
 * @param data
 * @returns
 */
export function getProductVideoList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<VideoItem[]>> {
	return request({
		method: 'POST',
		url: '/user/product/getProduct/video/list',
		data
	})
}

/**
 * 极速成片列表
 * @param data
 * @returns
 */
export function getProductList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<VideoItem[]>> {
	return request({
		method: 'POST',
		url: '/user/product/getProduct/list',
		data
	})
}

/**
 * 极速成片成功列表
 * @param data
 * @returns
 */
export function getProductSuccessList(data: {
	pageNum: number
	pageSize: number
	keyword: string
	taskStatus?: number
}): Promise<Response<VideoItem[]>> {
	data.taskStatus = 2
	return request({
		method: 'POST',
		url: '/user/product/getProduct/list',
		data
	})
}

/**
 * 素材成品列表
 * @param data
 * @returns
 */
export function getProductMaterialList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<VideoItem[]>> {
	return request({
		method: 'POST',
		url: '/user/product/getMaterialProduct/list',
		data
	})
}

/**
 * 数字人视频列表
 * @param data
 * @returns
 */
export function getProductionList(params: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<VideoItem[]>> {
	return request({
		method: 'GET',
		url: '/digitalHuman/getProductionList',
		params
	})
}

/**
 * MV成片视频列表
 * @param data
 * @returns
 */
export function getMvProductList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<VideoItem[]>> {
	return request({
		method: 'POST',
		url: '/user/product/getMvProduct/list',
		data
	})
}

/**
 * MV成片视频列表
 * @param data
 * @returns
 */
export function getMvProductSuccessList(data: {
	pageNum: number
	pageSize: number
	keyword: string
	taskStatus?: number
}): Promise<Response<VideoItem[]>> {
	data.taskStatus = 2
	return request({
		method: 'POST',
		url: '/user/product/getMvProduct/list',
		data
	})
}

// 素材分析状态
export function getMediaCataStatus(list: string[]) {
	return request({
		method: 'POST',
		url: '/media/getMediaCataStatus',
		data: list
	})
}
// 素材聚合状态查询
export function setMediaCaptionsAgg(list: string[]) {
	return request({
		method: 'POST',
		url: '/media/getMediaCaptionsAgg',
		data: list
	})
}
// 素材聚合状态查询
export function getMediaCaptionsAgg(id: string) {
	return request({
		method: 'get',
		url: '/media/getMediaCaptionsAgg?uuid=' + id
	})
}
// 获取微信 密钥
export function weChatKey(data: string) {
	return request({
		method: 'get',
		url: '/qrcode/getWeChatKey?url=' + data
	})
}
// 一件成片
export function materialSelectCreateVideo(data: {
	editText: string
	text: string
	mediaCaptionsAggUuid?: string | null
	footageUrlList: string[]
	resolution: string
}) {
	return request({
		method: 'POST',
		url: '/moonshot/getFilmingBySpecifyFootage',
		data
	})
}

// aimv
export function getFilmingBySpecifyFootageByAimv(data: {
	editText?: string
	text: string
	mediaCaptionsAggUuid?: string | null
	footageUrlList?: string[]
	musicId: string
	resolution: string
}) {
	return request({
		method: 'POST',
		url: '/moonshot/getFilmingBySpecifyFootage',
		data
	})
}
// 删除草稿
export function deleteDraftInterface(id: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: '/ovs/draft/delete',
		params: {
			id: id
		}
	})
}
// 删除个人作品
/**
 * @deprecated
 */
export function deleteDeleteProduct(id: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: '/user/product/deleteProduct',
		params: {
			id: id
		}
	})
}

export function deleteProductByTaskId(id: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: '/user/product/deleteProductByTaskId',
		params: {
			id: id
		}
	})
}
// 素材库
export function getMyMaterialBank(data: {
	pageSize: number
	pageNum: number
	searchType: number //keyword不为空时 传2  (默认为1)
	keyword: string //关键词搜索
	mediaAssetsDirId: string | null //选中文件夹id 顶层文件夹id固定为1
	needDir: boolean //是否需要结果包含文件夹(keyword为空  searchType为1时生效)  true-结果包含文件夹  false-不包含文件夹
	catalogStatus: number | null //编目状态
	proportion: number | null //比例
	type: number | null //资源类型
}): Promise<Response<MaterialCardData[]>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/assets/catalog/list',
		data
	})
}

// 获取文件夹层级目录
export function getDriList(data: { mediaAssetsDirId: string | null }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/dir/list',
		data
	})
}
// 移动素材或文件夹的目录层级
export function dirMove(data: {
	sourceIdList: string[]
	targetId: string | null
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/dir/move',
		data
	})
}

// 创建文件夹
export function createDir(data: {
	mediaAssetsDirId: string | null //父级文件夹id  (顶层文件夹id固定为1 )
	dirName: string //文件夹名称
}) {
	return request({
		method: 'POST',
		url: '/materialLibrary/dir/create',
		data
	})
}

// 文件夹重命名
export function renameDir(data: {
	mediaAssetsDirId: string // id
	dirName: string //文件夹名称
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/dir/rename',
		data
	})
}

// 根据场景描述匹配新的素材信息
export function fillMediaBySceneDesc(id: string): Promise<Response<any>> {
	return request({
		method: 'get',
		url: '/moonshot/fillMediaBySceneDesc?taskId=' + id
	})
}

// 批量删除素材
export function batchDeleteAsset(data: {
	mediaAssetsIdList: string[] //父级文件夹id  (顶层文件夹id固定为1 )
}) {
	return request({
		method: 'POST',
		url: '/materialLibrary/batchDeleteAsset',
		data
	})
}

// 批量删除素材
export function batchDeletedir(data: {
	dirIdList: string[] //父级文件夹id  (顶层文件夹id固定为1 )
}) {
	return request({
		method: 'POST',
		url: '/materialLibrary/dir/delete',
		data
	})
}

// 批量获取素材的编目状态及详情
export function getAssetsCatalog(data: { mediaAssetsIdList: string[] }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/getAssetsCatalog',
		data
	})
}

// 根据稿件ID查询合成任务列表
export function getTaskListById(data: {
	pageSize: Number
	pageNum: Number
	id: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/ovs/task/ListByDraftId',
		data
	})
}

/**
 * user相关 start
 */

// 登录
export function login(data: {
	userToken: string
	pwdToken: string
	imgVerify: string
}): Promise<Response<[ResponseLoginInfo]>> {
	return request({
		url: '/login/getUserLogin',
		method: 'get',
		headers: {
			userToken: data.userToken,
			pwdToken: data.pwdToken,
			imgVerify: data.imgVerify
		}
	})
}

// 退出登录
export function loginOut() {
	return request({ url: '/login/getUserLoginOut', method: 'get' })
}

/**
 * user相关 end
 */

// 获取全部ai视频列表
export function getAiVideoList(data: {
	pageNum: number
	pageSize: number
}): Promise<Response<any>> {
	return request({
		url: '/ai/video/list',
		method: 'POST',
		data
	})
}
// 获取生成成功的ai视频列表
export function getSucceedAiVideoList(data: {
	pageNum: number
	pageSize: number
}): Promise<Response<any>> {
	return request({
		url: '/ai/video/succeed/list',
		method: 'POST',
		data
	})
}
/**
 * @param {FormData} data
 * 上传分片
 */
export function multipartUpload(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/media/multipart/upload',
		data
	})
}

/**
 * @param {any} data
 *  确认是否素材重复
 */
export function multipartCheckUpload(data: any): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/media/checkUpload?${new URLSearchParams(data)}`
	})
}

export function deleteAiVideoByTaskIdList(list: string[]): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/ai/video/delete',
		data: {
			taskIds: list
		}
	})
}

/*
 *
 * 删除音乐
 *
 * */
export function generateAudioDelete(id: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/audio/generateAudio/delete?id=${id}`
	})
}
/*
 *
 * 删除音乐
 *
 * */
export function getProductByOvsTaskId(ovsTaskId: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/user/product/${ovsTaskId}/getProductByOvsTaskId`
	})
}

/*
 *
 * 获取用户信息
 *
 * */
export function getUserInfo(): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/user/userInfo`
	})
}

/*
 *
 * 批量查询草稿素材是否购买权限
 *
 * */
export function getAssetsRight(data: {
	urlList: string[]
	draftId: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/copyRight/getAssetsRight`,
		data
	})
}

/*
 *
 * 购买素材版权 单个
 *
 * */
export function copyRightPurchase(data: { url: string; draftId: string }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/copyRight/purchase`,
		data
	})
}

/*
 *
 * 购买素材版权批量 单个
 *
 * */
export function copyRightBatchPurchase(data: {
	urlList: string[]
	draftId: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/copyRight/batch/purchase`,
		data
	})
}

/*
 *
 * 无水印合成
 *
 * */
export function comboWithoutWatermark(data: {
	draftId: string
	taskJson: string
	productId: string
	videoName: string
	timeLineTotalDuration: number
	videoDirection: string // 横屏across 竖屏 down
	coverImg: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/ovs/task/combo/withoutWatermark`,
		data
	})
}

/*
 *
 * 查询用户是否需要操作指引
 *
 * */
export function getUserGuide(): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/user/guide`
	})
}

/*
 *
 * 用户通过操作指引确认
 *
 * */
export function setUserGuide(type: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/user/guide/${type}`
	})
}

/*
 *
 * 获取积分
 *
 * */
export function getPoints(): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/points/get`
	})
}
/*
 *
 * 注册账号
 *
 * */
export function registerAccountApi(data: {
	userName: string
	nickName: string
	password: string
	inviteCode: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/register/account`,
		data
	})
}
/**
 *
 * 获取积分使用详情
 */
export function getPointsDetail(): Promise<Response<[PointsDetail]>> {
	return request({ url: '/points/detail', method: 'GET' })
}
export function getTransactionList(data: {
	pageNum: number
	pageSize: number
	type: number
}): Promise<Response<PointsItem[]>> {
	return request({
		method: 'POST',
		url: '/points/getTransactionList',
		data
	})
}

// 获取企业微信的状态
export function loginWorkWechat(code: string): Promise<Response<[ResponseLoginInfo]>> {
	return request({
		method: 'GET',
		url: `/login/workWechat?code=${code}&state=STATE`
	})
}

// 获取用户存储情况及限制
export function getCapacity(): Promise<Response<[ResponseLoginInfo]>> {
	return request({
		method: 'GET',
		url: `/capacity/getCapacity`
	})
}
// 获取下载链接
export function getDownloadUrl(url: string, fileName: string): Promise<Response<[string]>> {
	return request({
		method: 'GET',
		url: `/mediaAssetsDownload/getDownloadUrl?url=${url}&fileName=${fileName}`
	})
}

/**
/**
 * 素材上传 不入素材库
 * @param {FormData} data
 */
export function multipartUploadGetUrl(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/media/multipart/upload/getUrl',
		data
	})
}

// 作者采写 文档解析
export function tfmcDocAnalysis(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/docAnalysis',
		data
	})
}
// 作者采写 音频解析
export function tfmcVoiceAnalysis(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/voiceAnalysis',
		data
	})
}
// 作者采写 联网搜索
export function tfmcWebSearch(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/webSearch',
		data
	})
}
// 作者采写 生成标题
export function tfmcGenerateTitle(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/generateTitle',
		data
	})
}
// 作者采写 生成摘要
export function tfmcGenerateAbstract(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/generateAbstract',
		data
	})
}
// 作者采写 生成标签
export function tfmcGenerateLabel(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/generateLabel',
		data
	})
}

// 作者采写 导出
export function tfmcExportPost(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/exportPost',
		data
	})
}

// 作者采写 保存
export function tfmcSave(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/tfmc/save',
		data
	})
}

// 手机号登录
export function validateCode(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/login/validateCode',
		data
	})
}

export function sendSmsCode(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/login/sendSmsCode',
		data
	})
}

export function validateTencentCaptcha(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/login/validateTencentCaptcha?ticket=${data.ticket}&randstr=${data.randstr}`
	})
}

// 视频拆条任务提交
export function stripSubmit(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/strip/submit`,
		data
	})
}

// 视频查询任务
export function stripGetTask(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/strip/getTask`,
		data
	})
}

// 获取历史记录列表
export function getHistoryList(params: QueryParams): Promise<Response<any>> {
	const requestParams: Record<string, any> = {
		pageNum: params.pageNum,
		pageSize: params.pageSize
	}
	if (params.title) {
		requestParams['title'] = params.title
	}

	return request({
		url: '/tfmc/list',
		method: 'post', // 改为 POST 请求
		headers: {
			'Content-Type': 'application/json'
		},
		data: requestParams // 使用 data 而不是 params 发送 JSON 数据
	})
}

// 删除历史记录
export function deleteHistoryRecords(data: { idList: string[] }): Promise<Response<any>> {
	return request({
		url: '/tfmc/delete',
		method: 'post',
		data
	})
}

// 视频拆条 列表
export function stripList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/strip/list`,
		data
	})
}

export function stripDelete(id: string): Promise<Response<VideoItem[]>> {
	return request({
		method: 'GET',
		url: '/strip/delete?id=' + id
	})
}

export function sseDisConnect(clientId: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/sse/disConnect?clientId=${clientId}`
	})
}

/**
 * @param {FormData} data
 * 根据任务id 查询timeline
 */
export function getTimelineTaskId(taskId: string, flag = false) {
	return request({
		method: 'GET',
		url: `/user/product/getTimeline?taskId=${taskId}&fillFlag=${flag}`
	})
}

/**
 * @param {Object} data
 * 根据text 获取视频id
 */
export function getFilmingBySpecifyFootage(data: {
	text: string
	resolution: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/moonshot/getFilmingBySpecifyFootage',
		data
	})
}

/**
 * @param {FormData} data
 * 获取草稿详情
 */
export function draftDetail(id: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/ovs/draft/detail?id=${id}`
	})
}

/**
 * @param {FormData} data
 * 朗读声Tab
 */
export function getReadAloudAllType(): Promise<Response<{ type: number; typeName: string }[]>> {
	return request({
		method: 'GET',
		url: `/audio/getReadAloudAllType`
	})
}

/**
 * @param {FormData} data
 * 朗读声列表
 */
export function readAloudAudio(
	data: number
): Promise<Response<{ concatenated: string; voiceId: string; auditionUrl: string }[]>> {
	return request({
		method: 'GET',
		url: `/audio/readAloudAudio?type=${data === 0 ? '' : data}`,
		data
	})
}

// 素材列表
export function getMyMaterialList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/assets/list',
		data
	})
}

/**
 * @param {FormData} data
 * 素材列表
 */
export function assetsList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/materialLibrary/cloud/assets/list',
		data
	})
}

/**
 * @param {FormData} data
 * 批量旁白合成语音（更改语速）
 */
export function asyncTtsWithSrt(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/audio/asyncTtsWithSrt',
		data
	})
}

/**
 * @param {FormData} data
 * 背景声Tab
 */
export function backgroundAudioType(): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/audio/backgroundAudioType`
	})
}

/**
 * @param {FormData} data
 * 背景声列表
 */
export function backgroundAudio(data: number): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/audio/backgroundAudio?type=${data === 0 ? '' : data}`,
		data
	})
}

// 重新合成声音
export function audioTtsWithSrt(data: {
	aside: string
	speed: number
	voiceName: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/audio/ttsWithSrt',
		data
	})
}

// 保存草稿
export function draftSave(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/ovs/draft/save',
		data
	})
}

// 分享获取路由二维码
export function shareQrCode(data: {
	width: string
	height: string
	url: string
	id?: string
	type?: string
}): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/qrcode/getShareCode?width=${data.width}&height=${data.height}&url=${data.url}&id=${data.id}&type=${data.type}`
	})
}
// 分享获取详情
export function shareDetail(data: { id?: string; type?: string }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/share/getDetail`,
		data
	})
}
// 查看点赞总数
export function likeCount(data: { bizId?: string; bizType?: string }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/share/getLikeCount`,
		data
	})
}
// 查看当前用户是否点赞
export function isLiked(data: { bizId?: string; bizType?: string }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/share/isLiked`,
		data
	})
}
// 点赞 or 取消点赞
export function toggleLike(data: { bizId?: string; bizType?: string }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/share/toggleLike`,
		data
	})
}
// 修改昵称
export function changeNickname(data: { nickName: string }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/nickname/change',
		data
	})
}

// 修改密码
export function changePassword(data: { oldPwd: string; newPwd: string }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/pwd/change',
		data
	})
}

// 注销账号
export function userCancel(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/cancel',
		data
	})
}

// 设置账号和密码
export function setUserAccount(data: {
	userName: string
	password: string
	pwdConfirm: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/account/set',
		data
	})
}

// 修改手机号
export function changeMobile(data: {
	oldMobile: string
	oldMobileCode: string
	newMobile: string
	newMobileCode: string
	areaCode?: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/mobile/change',
		data
	})
}

// 验证旧手机号验证码
export function validOldMobileCode(data: {
	oldMobile: string
	oldMobileCode: string
	areaCode?: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/changeMobile/validOldMobileCode',
		data
	})
}

/**
 * 获取最新标题
 */
export function generateTitle(data: { text: String; taskId: String }) {
	return request({
		method: 'POST',
		url: '/moonshot/generateTitle',
		data
	})
}

/**
 * @param {FormData} data
 * 合成视频
 */
export function apiComboVideo(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/ovs/task/combo',
		data
	})
}

/**
 * @param {FormData} data
 * 合成视频
 */
export function setBgm(id: any): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/audio/setBgm?id=${id}`
	})
}

/**
 * @param {FormData} data
 * 合成视频
 */
export function audioTimbreCloning(data: {
	userCustomizeVoiceID: string //音色id
	aiMusicID: number //ai音乐id
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/audio/timbreCloning`,
		data
	})
}

/**
 * @param {FormData} data
 * 批量删除拆条
 */
export function stripBatchDelete(data: { idList: string[] }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/strip/batch/delete`,
		data
	})
}

interface MoonshotEditParam {
	text?: string // 输入 prompt
	tag: '0' | '1' // 0：编辑标题；1：编辑旁白
	editText: string //编辑的标题或旁白
	speed?: number
	voiceName?: string
	clientId?: string
	footageUrlList?: string[]
	mediaCaptionsAggUuid?: string
	textType?: string
	durationType?: number
	taskId?: string
}

export function moonshotEdit(data: MoonshotEditParam): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/moonshot/edit',
		data
	})
}

// 全部音乐列表
export function getAllMusicList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/product/getProduct/music/list',
		data
	})
}

// 全部图文作品列表
export function getAllImageList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/user/product/getProduct/image/list',
		data
	})
}

// 选择克隆音频列表
export function getUserCloneAudioList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `userVoice/record/getUserCloneAudioList`,
		data
	})
}

// 翻译任务列表
export function translationTaskList(data: any): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/videoTranslate/translation/task/list`,
		data
	})
}

// 翻译任务成功列表
export function translationTaskSuccessList(data: any): Promise<Response<any>> {
	data.status = 6
	return request({
		method: 'POST',
		url: `/videoTranslate/translation/task/list`,
		data
	})
}

// 数字人列表
export function getMaterialLibraryList(params: {
	kind?: number
	type: number
	userId?: string
}): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/digitalHuman/getMaterialLibraryList`,
		params
	})
}

// 获取视频超分列表
export function getVideoStormList(data: {
	pageNum: number
	pageSize: number
	keyword: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/videoStorm/getVideoStormList`,
		data
	})
}

// 生成视频超分任务
export function generateVideoStorm(data: {
	originalCoverUrl: string //原素材封面图
	originalUrl: string //原素材url
	originalDuration: number // 原始素材时长
	originalSize: number // 原始素材大小mb
	originalName: string //原始素材名称
	originalResolution: string //原始素材分辨率
	generateResolution: string //生成视频分辨率
	resolutionValue: string //分辨率（1080p，4k，2k 3选一）
	point: any //创作值
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/videoStorm/generateVideoStorm`,
		data
	})
}

// 获取视频超分任务状态
export function getGenerateVideoStormStatus(data: { taskIds: string[] }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/videoStorm/getGenerateVideoStormStatus`,
		data
	})
}

// 图片超分
export function generateImageStorm(data: FormData): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/videoStorm/generateImageStorm`,
		data
	})
}

// 图片超分
export function deleteVideoStorm(data: { ids: string[] }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/videoStorm/deleteVideoStorm`,
		data
	})
}

// 获取全部曲风
export function getAllStyle(): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/audio/getAllStyle`
	})
}

// 创造mv
export function convertToMV(data: {
	timeLineJson: string
	musicId: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/moonshot/timeline/convertToMV`,
		data
	})
}

// 生成音乐
export function generateAudio(data: {
	custom: boolean //true，代表自定义生成，false代表使用 prompt 生成
	instrumental: number //是否纯音乐 1-是 0-否 默认为0
	lyric: string
	prompt?: string
	style?: string
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: '/audio/generateAudio',
		data
	})
}

export function generateAudioTask(id: string): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/audio/generateAudio/task?id=${id}`
	})
}
// 生成风格迁移
export function generateStyleTransfer(data: {
	originalUrl: string
	originalName: string
	styleId: string
}): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/styleTransfer/generateStyleTransfer`,
		data
	})
}
// 轮询风格迁移
export function getGenerateStyleTransferStatus(data: {
	taskIds: string[]
}): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/styleTransfer/getGenerateStyleTransferStatus`,
		data
	})
}
// 删除风格迁移
export function deleteStyleTransfer(data: { ids: string[] }): Promise<Response<any>> {
	console.log(data)
	return request({
		method: 'post',
		url: `/styleTransfer/deleteStyleTransfer`,
		data
	})
}
// 获取风格迁移列表
export function getStyleTransferList(data: {
	pageNum: number
	pageSize: number
	keyword?: string
}): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/styleTransfer/getStyleTransferList`,
		data
	})
}
// 获取风格列表
export function getStyleList(): Promise<Response<any>> {
	return request({
		method: 'get',
		url: `/styleTransfer/getStyleList`
	})
}

// 老照片修复
export function estorationPhotoRepair(data: {
	imageUrl: string
	name: string
	resolution: string
	size: number
}): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/repair/submit`,
		data
	})
}
// 老照片修复轮询
export function getTaskStatus(data: { idList: string[] }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/repair/getTaskStatus`,
		data
	})
}
// 获取老照片修复列表
export function getTaskList(data: {
	pageNum: number
	pageSize: number
	keyword?: string
}): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/repair/getTaskList`,
		data
	})
}
// 删除老照片修复
export function deleteTaskList(data: { idList: string[] }): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/repair/delete`,
		data
	})
}

/**
 *  @param {FormData} data  删除音色
 */
export function recordDelete(data: { idList: string[] }): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/userVoice/record/delete`,
		data
	})
}

// 删除视频转译
export function translationDelete(id: number): Promise<Response<any>> {
	return request({
		method: 'GET',
		url: `/videoTranslate/translation/delete/${id}`
	})
}

// 删除右侧数字人视频
export function deleteProduction(ids: string): Promise<Response<any>> {
	return request({
		method: 'post',
		url: `/digitalHuman/deleteProduction`,
		data: { ids: [ids] }
	})
}

// 菜单路由列表
export function menuRouteList(): Promise<Response<any>> {
	return request({
		method: 'get',
		url: `/featureRemind/menu/getFeatureRemindList`
	})
}

//批量修改视频编目
export function batchModifyCatalog(data: {
	mediaList: {
		mediaAssetsId: string
		fragments: {
			url: string
			customize: string[]
		}[]
	}[]
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/materialLibrary/batch/modifyCatalog`,
		data
	})
}

//修改单个片段编目
export function modifyCatalog(data: {
	customize: string[] //业务标签列表
	mediaAssetId: string //素材id
	index: number //片段索引下标
}): Promise<Response<any>> {
	return request({
		method: 'POST',
		url: `/materialLibrary/modifyCatalog`,
		data
	})
}
